import { Injectable } from '@angular/core';
import { PlanFeature, PlanInformation } from '../model/response/account-response';

@Injectable({ providedIn: 'root' })
export class PlanFeatureService {
  private features: PlanFeature[] = [];
  private _planId: string | null = null;
  private _billingType: 'stripe' | 'manual' | null = null;

  get planId(): string | null {
    return this._planId;
  }

  get billingType(): 'stripe' | 'manual' | null {
    return this._billingType;
  }

  load(planInformation: PlanInformation | null | undefined): void {
    this.features = planInformation?.features ?? [];
    this._planId = planInformation?.planId ?? null;
    this._billingType = planInformation?.billingType ?? null;
  }

  hasFeature(key: string): boolean {
    return this.features.some(f => f.key === key && f.value === 'true');
  }

  featureLimit(key: string): number {
    const val = this.features.find(f => f.key === key)?.value;
    return val !== undefined ? parseInt(val, 10) : 0;
  }
}
